import Service from "../Service";

const resource = "materialReceptionTransport/"

export default {

  pagination(parameters, requestID) {
    return Service.post(resource + "pagination", parameters, {
        params: { requestID: requestID },
    });
  },   

  save(cmp, requestID) {
    return Service.post(resource + "save", cmp, {
        params: { requestID: requestID },
    });
  },

  getTransport(requestID, RcsID) {
    // alert("service", RcsID)
    return Service.post(resource + "getTransport", "", {
        params: { requestID: requestID, RcsID: RcsID },
    });
  },


};